import React from "react"
import GeneralTables from "components/Common/GeneralTable"

const ReportTable = ({
  visibleColumns = [],
  data,
  loading,
  pagination,
  parentCheckbox,
  onParentCheckChange,
}) => {
  return (
    <GeneralTables
      data={data}
      loading={loading}
      parentCheckbox={parentCheckbox}
      onParentCheckChange={onParentCheckChange}
      headers={visibleColumns.map(column => column.label)}
      pagination={pagination}
      renderItem={(row, index) => (
        <tr key={row?.id ? `${row.id}-${index}` : row?.unique_id || index}>
          {visibleColumns.map(column => (
            <td
              key={column.key}
              style={column.style || { whiteSpace: "nowrap" }}
            >
              {column.render(row, index)}
            </td>
          ))}
        </tr>
      )}
    />
  )
}

export default ReportTable
